import './SubmissionHistory.css';

export default function SubmissionHistory({ history }) {
  return (
    <div className="submission-history">
      <h4>Historique</h4>
      {history?.length ? (
        <ul>
          {history.map((item) => (
            <li key={item.id}>
              <span className="title">{item.title}</span>
              <span className="date">{item.date}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="muted">Aucun plan pour le moment.</p>
      )}
    </div>
  );
}
